import React, { useState, useEffect } from "react";
import { Button, Modal, Row, Col, Input, Select,DatePicker } from "antd";
import "./billingExtend.css";

import { useDispatch, useSelector } from "react-redux";
import BidAmount from "../PlaceBidModal/BidAmount/BidAmount";
import { updateBid, updateProposal } from "../../redux/actions";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const contrachLengthOptions = [
  {
    IdealContractLengthId: 1,
    IdealContractLengthName: "1 month",
    IdealContractLengthValue: 1,
  },
  {
    IdealContractLengthId: 2,
    IdealContractLengthName: "2 months",
    IdealContractLengthValue: 2,
  },
  {
    IdealContractLengthId: 3,
    IdealContractLengthName: "3 months",
    IdealContractLengthValue: 3,
  },
  {
    IdealContractLengthId: 4,
    IdealContractLengthName: "4 months",
    IdealContractLengthValue: 4,
  },
  {
    IdealContractLengthId: 5,
    IdealContractLengthName: "5 months",
    IdealContractLengthValue: 5,
  },
  {
    IdealContractLengthId: 6,
    IdealContractLengthName: "6 months",
    IdealContractLengthValue: 6,
  },
  {
    IdealContractLengthId: 7,
    IdealContractLengthName: "7 months",
    IdealContractLengthValue: 7,
  },
  {
    IdealContractLengthId: 8,
    IdealContractLengthName: "8 months",
    IdealContractLengthValue: 8,
  },
  {
    IdealContractLengthId: 9,
    IdealContractLengthName: "9 months",
    IdealContractLengthValue: 9,
  },
  {
    IdealContractLengthId: 10,
    IdealContractLengthName: "10 months",
    IdealContractLengthValue: 10,
  },
  {
    IdealContractLengthId: 11,
    IdealContractLengthName: "11 months",
    IdealContractLengthValue: 11,
  },
  {
    IdealContractLengthId: 12,
    IdealContractLengthName: "1 year",
    IdealContractLengthValue: 12,
  },
  {
    IdealContractLengthId: 13,
    IdealContractLengthName: "1+ years",
    IdealContractLengthValue: 13,
  },
  {
    IdealContractLengthId: 14,
    IdealContractLengthName: "Negotiable",
    IdealContractLengthValue: 14,
  },
  {
    IdealContractLengthId: 15,
    IdealContractLengthName: "13 weeks",
    IdealContractLengthValue: 15,
  },
  {
    IdealContractLengthId: 16,
    IdealContractLengthName: "1 Week",
    IdealContractLengthValue: 16,
  },
  {
    IdealContractLengthId: 17,
    IdealContractLengthName: "6 weeks",
    IdealContractLengthValue: 17,
  },
  {
    IdealContractLengthId: 18,
    IdealContractLengthName: "12 weeks",
    IdealContractLengthValue: 18,
  },
];

export default function BillingExtendModal({
  visible,
  setVisible,
  desired_rate,
  onClose,
  bidId,
  skillListingId,
  receivedId,
  source,
  gapExist,
}) {
  const dispatch = useDispatch();

  const [rateType, setrateType] = useState("Week");
  const [rateError, setRateError] = useState();
  const [rate, setrate] = useState(0);
  const [contractLength, setContractLength] = useState();
  const [currencyType, setcurrencyType] = useState("USD");
  const [selectedDate, setSelectedDate] = useState(null);

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const loading  = useSelector((state) => state.updateProposalReducers.loading)

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const backHandler = () => {
    if (contractLength) {
      setContractLength();
    } else {
      onClose();
    }
    return;
  };
  const nextHandler = () => {
    if (!contractLength) {
      setContractLength("1+ Years");
    } else {

      if (source == 1) {
        dispatch(
          updateBid({
            BidStatusName: "Billing Extend",
            id: bidId,
            SkillListingId: skillListingId,
            BudgetType: rateType,
            Rate: rate,
            contractDuration: contractLength,
            ...(gapExist && {StartDate: selectedDate?.toISOString()})
          })
        );
        setVisible(false);
      } else {
        dispatch(
          updateProposal({
            status: "Billing Extend",
            id: receivedId,
            BudgetType: rateType,
            Rate: rate,
            contractDuration: contractLength,
            ...(gapExist && {StartDate: selectedDate?.toISOString()})
          })
        );
        setVisible(false);
      }
    }
  };

  const closemeHandle = () => {
    onClose();
    return;
  };
  const handleChange = (value) => {
    setContractLength(value)
  };
  const handleDate =(date)=>{
    setSelectedDate(date);
  }
  const disablePastDates = (current) => {
    return current && current < dayjs().startOf("day");
  };

  return (
    <>
      <Modal
        open={visible}
        title={contractLength ? "Extend contract" : "Add estimated pay"}
        bodyStyle={{ padding: "15px" }}
        style={{ top: "10px" }}
        onOk={nextHandler}
        onCancel={closemeHandle}
        width={windowDimensions.width < 992 ? "99%" : "60%"}
        footer={
          <div className="modalFooterPB">
            <Button
              key="back"
              className="backBtnPlaceBid centerElement textPlaceBid"
              onClick={backHandler}
            >
              Back
            </Button>

            <button
              style={{ border: "none" , cursor: rate <= 0 ? "not-allowed" : "pointer" }}
              className={`nextBtnPlaceBid nextBtnPlaceBid-nextPadding centerElement textPlaceBid`}
              onClick={nextHandler}
              disabled={rate <=0 }
            >
              {loading ? <LoadingOutlined /> : 'Next'}
            </button>
          </div>
        }
      >
        {!contractLength ? (
          <div style={{ height: "20rem" }}>
            <BidAmount
              desiredRate={desired_rate}
              rate={rate}
              setrate={setrate}
              rateType={rateType}
              setrateType={setrateType}
              currencyType={currencyType}
              setcurrencyType={setcurrencyType}
              setRateError={setRateError}
              extendBilling={true}
            />
          </div>
        ) : (
          gapExist ?
          <div style={{display:"flex",height:"20rem", justifyContent:"space-between", paddingLeft:"15px", width:"95%"}}>
            <div>
             <h3>Start Date</h3>
             <DatePicker className="date-picker" value={selectedDate} onChange={handleDate} format="MM/DD/YYYY" disabledDate={disablePastDates} />
            </div>
            <div>
            <h2 style={{fontSize:"16px", fontWeight:"600", paddingLeft:"12px"}}>Contract Length</h2>
            <Select
              defaultValue="1 + years"
              style={{
                width: "280px",
                border:"1px solid #E4E4E4",
                marginLeft:"10px"
              }}
              onChange={handleChange}
              options={contrachLengthOptions?.map((item) => {
                return { value: item.IdealContractLengthName, label: item.IdealContractLengthName };
              })}
            />
            </div>
          </div>:
          <div style={{ height: "20rem"}}>
            <h2 style={{fontSize:"16px", fontWeight:"600", paddingLeft:"12px"}}>Contract Length</h2>
            <Select
              defaultValue="1+ Years"
              style={{
                width: "98%",
                border:"1px solid #E4E4E4",
                marginLeft:"10px"
              }}
              onChange={handleChange}
              options={contrachLengthOptions?.map((item) => {
                return { value: item.IdealContractLengthName, label: item.IdealContractLengthName };
              })}
            />
          </div>
          )
        }
      </Modal>
    </>
  );
}
